import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientLinkList } from '../types';

const useNexhealthPatientLink = (
    agentId: string,
    customerId: string,
    enabled = false,
) => useHttpQuery<NexhealthPatientLinkList>({
    pathname: `/organizations/${agentId}/apps/nexhealth/patient-links?customerId=${encodeURIComponent(customerId)}&includeStale=true&limit=1`,
    server: ACTIONS_BASE_URL,
    key: ['nexhealth', 'patient-link', agentId, customerId],
    queryOptions: {
        enabled: Boolean(agentId && customerId) && enabled,
        retry: false,
    },
});

export default useNexhealthPatientLink;
